var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExtendClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.92 330.199H263.17C259.94 330.199 257.31 327.569 257.31 324.339V61.0592C257.31 57.8292 259.94 55.1992 263.17 55.1992H443.92C447.15 55.1992 449.78 57.8292 449.78 61.0592V324.339C449.78 327.569 447.15 330.199 443.92 330.199ZM263.17 55.4492C260.08 55.4492 257.56 57.9692 257.56 61.0592V324.339C257.56 327.429 260.08 329.949 263.17 329.949H443.92C447.01 329.949 449.53 327.429 449.53 324.339V61.0592C449.53 57.9692 447.01 55.4492 443.92 55.4492H263.17Z",
    fill: "#FFB000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.49 330.199H54.75C51.52 330.199 48.89 327.569 48.89 324.339V61.0592C48.89 57.8292 51.52 55.1992 54.75 55.1992H235.49C238.72 55.1992 241.35 57.8292 241.35 61.0592V324.339C241.35 327.569 238.72 330.199 235.49 330.199ZM54.75 55.4492C51.66 55.4492 49.14 57.9692 49.14 61.0592V324.339C49.14 327.429 51.66 329.949 54.75 329.949H235.49C238.58 329.949 241.1 327.429 241.1 324.339V61.0592C241.1 57.9692 238.58 55.4492 235.49 55.4492H54.75Z",
    fill: "#FFB000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 391.27H0V391.52H500V391.27Z",
    fill: "#FFB000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.73 405.529H51.67V405.779H67.73V405.529Z",
    fill: "#FFB000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.88 402.818H170.35V403.068H223.88V402.818Z",
    fill: "#FFB000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.98 414.818H68.73V415.068H104.98V414.818Z",
    fill: "#FFB000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.54 402.689H378.35V402.939H421.54V402.689Z",
    fill: "#FFB000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.78 402.689H430.45V402.939H436.78V402.689Z",
    fill: "#FFB000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.1 408.92H316.21V409.17H370.1V408.92Z",
    fill: "#FFB000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.41 49.2895C138.48 47.8295 135.65 47.6595 133.56 48.8895C130.78 43.2795 123.05 40.7995 117.53 43.7595C116.09 37.7095 110.13 33.0695 103.92 33.1395C97.7 33.2095 91.86 37.9995 90.57 44.0795C90.36 45.0495 90.23 46.0995 89.54 46.8095C88.42 47.9595 86.54 47.5695 84.94 47.4495C79.91 47.0595 74.84 50.5895 73.47 55.4495L142.79 55.1995C143.4 52.8495 142.35 50.7495 140.42 49.2895H140.41Z",
    fill: "#0C66E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.56 64.85C429.63 63.39 426.8 63.22 424.71 64.45C421.93 58.84 414.2 56.36 408.68 59.32C407.24 53.27 401.28 48.63 395.07 48.7C388.85 48.77 383.01 53.56 381.72 59.64C381.51 60.61 381.38 61.66 380.69 62.37C379.57 63.52 377.69 63.13 376.09 63.01C371.06 62.62 365.99 66.15 364.62 71.01L433.94 70.76C434.55 68.41 433.5 66.31 431.57 64.85H431.56Z",
    fill: "#0C66E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.5 193.76C467.57 192.3 464.74 192.13 462.65 193.36C459.87 187.75 452.14 185.27 446.62 188.23C445.18 182.18 439.22 177.54 433.01 177.61C426.79 177.68 420.95 182.47 419.66 188.55C419.45 189.52 419.32 190.57 418.63 191.28C417.51 192.43 415.63 192.04 414.03 191.92C409 191.53 403.93 195.06 402.56 199.92L471.88 199.67C472.49 197.32 471.44 195.22 469.51 193.76H469.5Z",
    fill: "#EE3853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.08 169.07C99.68 167.26 96.19 167.05 93.59 168.57C90.15 161.62 80.56 158.55 73.72 162.21C71.94 154.72 64.55 148.96 56.85 149.05C49.15 149.14 41.91 155.08 40.3 162.61C40.05 163.81 39.88 165.12 39.02 165.99C37.63 167.41 35.31 166.93 33.32 166.78C27.08 166.29 20.81 170.67 19.11 176.69L105 176.38C105.75 173.47 104.46 170.87 102.06 169.06L102.08 169.07Z",
    fill: "#0C66E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.77 252.919C126.37 251.109 122.88 250.899 120.28 252.419C116.84 245.469 107.25 242.399 100.41 246.059C98.63 238.569 91.24 232.809 83.54 232.899C75.84 232.989 68.6 238.929 66.99 246.459C66.74 247.659 66.57 248.969 65.71 249.839C64.32 251.259 62 250.779 60.01 250.629C53.77 250.139 47.5 254.519 45.8 260.539L131.69 260.229C132.44 257.319 131.15 254.719 128.75 252.909L128.77 252.919Z",
    fill: "#0C66E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.81 38.5196C290.73 36.9496 287.69 36.7696 285.44 38.0896C282.45 32.0496 274.12 29.3796 268.18 32.5696C266.63 26.0596 260.22 21.0596 253.52 21.1396C246.83 21.2196 240.54 26.3796 239.14 32.9196C238.92 33.9596 238.77 35.0996 238.03 35.8596C236.82 37.0896 234.8 36.6796 233.08 36.5496C227.66 36.1296 222.21 39.9296 220.73 45.1596L295.36 44.8896C296.01 42.3596 294.89 40.0996 292.81 38.5296V38.5196Z",
    fill: "#EE3853"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M458.88 445.15C458.88 448.54 365.36 451.28 250 451.28C134.64 451.28 41.12 448.53 41.12 445.15C41.12 441.77 134.64 439.02 250 439.02C365.36 439.02 458.88 441.77 458.88 445.15Z",
    fill: "#EE3853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M461.02 290.07C445.07 308.72 440.42 336.33 449.36 359.19C459.3 350.32 466.3 336.8 466.74 324.97C467.18 313.14 464.09 301.5 461.02 290.07Z",
    fill: "#008978"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M458.24 361.34C452.83 369.63 450.24 379.73 450.99 389.6C459.61 386.6 467.21 376.86 471.77 368.95C476.33 361.04 478.87 352.16 481.19 343.33C471.85 346.62 463.65 353.05 458.24 361.34Z",
    fill: "#008978"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M456.2 322.641C449.8 345.641 446.54 369.481 446.55 393.351C446.55 400.181 446.83 407.011 447.36 413.821C447.4 414.301 448.15 414.301 448.11 413.821C446.24 389.931 447.63 365.811 452.29 342.301C453.59 335.751 455.14 329.261 456.93 322.831C457.06 322.361 456.34 322.171 456.21 322.631L456.2 322.641Z",
    fill: "#FF6D00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M447.64 397.41C454.19 381.83 462.79 367.24 472.73 353.6C473.01 353.21 472.36 352.83 472.08 353.22C462.1 366.92 453.49 381.56 446.92 397.2C446.73 397.64 447.46 397.84 447.64 397.4V397.41Z",
    fill: "#FF6D00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M438.31 374.26C442.82 381.17 444.98 389.59 444.35 397.82C437.16 395.32 430.83 387.2 427.03 380.6C423.23 374 421.11 366.6 419.17 359.24C426.96 361.98 433.79 367.35 438.31 374.26Z",
    fill: "#008978"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M447.44 403.27C442.07 390.49 434.97 378.65 426.82 367.47C426.54 367.08 425.89 367.46 426.17 367.85C434.28 378.98 441.37 390.76 446.71 403.47C446.89 403.91 447.62 403.72 447.43 403.27H447.44Z",
    fill: "#FF6D00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M447.68 407.561C457.82 397.121 468.18 386.901 478.32 376.461C478.66 376.111 478.13 375.581 477.79 375.931C467.65 386.371 457.29 396.591 447.15 407.031C446.81 407.381 447.34 407.911 447.68 407.561Z",
    fill: "#FF6D00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M478.67 371.631C469.87 380.121 461.85 389.421 454.75 399.371H456.36C463.06 399.061 469.56 395.751 473.76 390.531C477.96 385.311 479.8 378.241 478.67 371.631Z",
    fill: "#008978"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M436.97 351.41C440.75 357.59 444.31 363.9 447.64 370.33C447.86 370.76 448.51 370.38 448.29 369.95C444.95 363.52 441.39 357.21 437.62 351.03C437.37 350.62 436.72 351 436.97 351.41Z",
    fill: "#FF6D00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M427.9 320.189C426.46 326.669 425.03 335.099 425.02 341.849C425.01 348.599 427.06 355.189 430.9 359.709C434.74 364.229 442.48 366.209 445.6 363.629L427.91 320.189H427.9Z",
    fill: "#008978"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M466.14 410.541H427.7V417.661H466.14V410.541Z",
    fill: "#FF6D00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M459.92 443.041H436.05L431.71 416.031H463.35L459.92 443.041Z",
    fill: "#FF6D00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M432 417.791H463.13L462.74 420.851H432.49L432 417.791Z",
    fill: "#EE3853"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8 288.98C59.75 307.63 64.4 335.24 55.46 358.1C45.52 349.23 38.52 335.71 38.08 323.88C37.64 312.05 40.73 300.41 43.8 288.98Z",
    fill: "#008978"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M46.58 360.25C51.99 368.54 54.58 378.64 53.83 388.51C45.21 385.51 37.61 375.77 33.05 367.86C28.49 359.95 25.95 351.07 23.63 342.24C32.97 345.53 41.17 351.96 46.58 360.25Z",
    fill: "#008978"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M47.89 321.741C54.31 344.831 57.57 368.761 57.51 392.731C57.5 399.401 57.22 406.071 56.7 412.731C56.66 413.211 57.41 413.211 57.45 412.731C59.31 388.931 57.93 364.911 53.34 341.481C52.03 334.781 50.44 328.131 48.61 321.541C48.48 321.081 47.76 321.271 47.89 321.741Z",
    fill: "#FF6D00"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9 396.12C51.33 380.48 42.72 365.83 32.74 352.14C32.46 351.75 31.81 352.13 32.09 352.52C42.03 366.16 50.63 380.75 57.18 396.33C57.36 396.77 58.09 396.58 57.9 396.13V396.12Z",
    fill: "#FF6D00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M66.51 373.17C62 380.08 59.84 388.5 60.47 396.73C67.66 394.23 73.99 386.11 77.79 379.51C81.59 372.91 83.71 365.51 85.65 358.15C77.86 360.89 71.03 366.26 66.51 373.17Z",
    fill: "#008978"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1 402.371C63.45 389.661 70.53 377.871 78.64 366.751C78.92 366.361 78.27 365.981 77.99 366.371C69.84 377.561 62.74 389.401 57.37 402.171C57.18 402.611 57.91 402.811 58.09 402.371H58.1Z",
    fill: "#FF6D00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M57.66 405.93C47.52 395.49 37.16 385.27 27.02 374.83C26.68 374.48 26.15 375.01 26.49 375.36C36.63 385.8 46.99 396.02 57.13 406.46C57.47 406.81 58 406.28 57.66 405.93Z",
    fill: "#FF6D00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.14 370.531C34.94 379.021 42.96 388.321 50.06 398.271H48.45C41.75 397.961 35.25 394.651 31.05 389.431C26.85 384.211 25.01 377.141 26.14 370.531Z",
    fill: "#008978"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M67.19 349.94C63.41 356.12 59.85 362.43 56.52 368.86C56.3 369.29 56.95 369.67 57.17 369.24C60.51 362.81 64.07 356.5 67.84 350.32C68.09 349.91 67.44 349.53 67.19 349.94Z",
    fill: "#FF6D00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M76.91 319.09C78.35 325.57 79.78 334 79.8 340.75C79.81 347.5 77.76 354.09 73.92 358.61C70.08 363.13 62.34 365.11 59.22 362.53L76.91 319.09Z",
    fill: "#008978"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M38.67 416.57H77.11V409.45H38.67V416.57Z",
    fill: "#FF6D00"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M44.89 441.95H68.77L73.1 414.93H41.47L44.89 441.95Z",
    fill: "#FF6D00"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.82 416.701H41.69L42.08 419.761H72.33L72.82 416.701Z",
    fill: "#EE3853"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M263.548 95.2422H244.03V125.692H263.548V95.2422Z",
    fill: "#FF6D00"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M274.005 104.313H233.816V71.5189C247.879 68.0537 261.326 67.8415 274.005 71.5189V104.313Z",
    fill: "url(#paint0_linear_2468_15433)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M274.48 71.661C274.016 71.9648 273.517 72.2124 272.995 72.3985C271.634 73.0175 270.237 73.5539 268.812 74.0048C266.677 74.6668 264.5 75.1832 262.296 75.5505C259.589 75.9813 256.854 76.2143 254.112 76.2476C251.373 76.2442 248.638 76.0382 245.929 75.6314C243.719 75.2854 241.535 74.7892 239.393 74.1463C237.95 73.7238 236.533 73.2178 235.15 72.6308C234.63 72.445 234.133 72.2045 233.664 71.9135C233.664 71.7923 235.877 72.7016 239.534 73.6815C241.668 74.2493 243.834 74.6912 246.02 75.005C248.699 75.3695 251.399 75.5551 254.102 75.5606C256.808 75.5359 259.509 75.3232 262.185 74.9242C264.372 74.5926 266.538 74.1304 268.671 73.5401C272.267 72.4793 274.429 71.5397 274.48 71.661Z",
    fill: "#67266D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M247.091 104.313C246.899 104.313 246.747 98.0086 246.747 90.2395C246.747 82.4705 246.899 76.1562 247.091 76.1562C247.283 76.1562 247.434 82.4604 247.434 90.2395C247.434 98.0187 247.283 104.313 247.091 104.313Z",
    fill: "#67266D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M254.739 104.444C254.547 104.444 254.395 98.1197 254.395 90.3002C254.395 82.4806 254.547 76.1562 254.739 76.1562C254.931 76.1562 255.082 82.4806 255.082 90.3002C255.082 98.1197 254.931 104.444 254.739 104.444Z",
    fill: "#67266D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M262.387 104.315C262.195 104.315 262.043 97.9807 262.043 90.1713C262.043 82.3618 262.195 76.0273 262.387 76.0273C262.579 76.0273 262.73 82.3517 262.73 90.1713C262.73 97.9908 262.579 104.315 262.387 104.315Z",
    fill: "#67266D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M268.751 104.315C268.559 104.315 268.408 97.4753 268.408 89.0293C268.408 80.5834 268.559 73.7539 268.751 73.7539C268.943 73.7539 269.095 80.5935 269.095 89.0293C269.095 97.4652 268.943 104.315 268.751 104.315Z",
    fill: "#67266D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M239.857 104.13C239.665 104.13 239.514 97.28 239.514 88.8441C239.514 80.4083 239.665 73.5586 239.857 73.5586C240.049 73.5586 240.201 80.4083 240.201 88.8441C240.201 97.28 240.049 104.13 239.857 104.13Z",
    fill: "#67266D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M374.667 144.62L364.916 134.416L348.994 149.632L358.745 159.836L374.667 144.62Z",
    fill: "#FF6D00"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M375.124 154.648L355.049 133.614L372.224 117.217C381.074 122.834 387.893 129.754 392.308 138.231L375.124 154.648Z",
    fill: "url(#paint1_linear_2468_15433)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M358.403 137.149C358.292 137.027 362.182 133.107 367.092 128.339C372.002 123.57 376.083 119.842 376.184 119.954C376.285 120.065 372.406 123.995 367.496 128.763C362.586 133.532 358.515 137.27 358.403 137.149Z",
    fill: "#67266D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M362.233 141.159C363.033 140.208 363.908 139.323 364.849 138.512C366.506 136.936 368.83 134.784 371.406 132.45L378.043 126.449L380.064 124.641C380.549 124.216 380.791 123.994 380.812 123.994C381.034 124.196 376.962 128.177 371.8 132.885C369.224 135.249 366.86 137.35 365.122 138.845C364.222 139.693 363.256 140.466 362.233 141.159Z",
    fill: "#67266D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M367.324 146.488C368.141 145.537 369.03 144.648 369.981 143.831C371.658 142.245 374.022 140.083 376.639 137.709L383.388 131.647L385.408 129.849C385.655 129.625 385.915 129.416 386.186 129.223C385.445 130.236 384.583 131.155 383.62 131.961C381.953 133.567 379.579 135.739 376.983 138.113C374.386 140.487 371.931 142.589 370.204 144.104C369.311 144.976 368.348 145.774 367.324 146.488Z",
    fill: "#67266D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M372.093 151.348C371.982 151.227 375.922 147.307 380.902 142.599C385.883 137.891 389.995 134.153 390.106 134.274C390.217 134.396 386.277 138.315 381.296 143.023C376.316 147.731 372.204 151.459 372.093 151.348Z",
    fill: "#67266D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M128.772 143.128L118.19 152.467L132.764 168.98L143.345 159.641L128.772 143.128Z",
    fill: "#FF6D00"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M138.799 143.067L117.007 162.263L101.298 144.502C107.278 135.894 114.431 129.348 123.099 125.307L138.799 143.067Z",
    fill: "url(#paint2_linear_2468_15433)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M120.655 159.086C120.533 159.197 116.755 155.156 112.199 150.054C107.642 144.952 104.116 140.74 104.187 140.639C104.258 140.538 108.087 144.569 112.643 149.67C117.199 154.772 120.776 158.985 120.655 159.086Z",
    fill: "#67266D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M124.807 155.417C123.912 154.578 123.081 153.673 122.321 152.71C120.816 150.982 118.755 148.578 116.502 145.911L110.764 139.041L108.986 136.95C108.582 136.444 108.37 136.202 108.37 136.172C108.582 135.96 112.411 140.213 116.906 145.527C119.159 148.204 121.16 150.649 122.594 152.437C123.412 153.369 124.152 154.365 124.807 155.417Z",
    fill: "#67266D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M130.343 150.536C129.422 149.688 128.567 148.769 127.787 147.788C126.272 146.04 124.201 143.606 121.938 140.888L116.189 133.907L114.472 131.765C114.248 131.515 114.049 131.244 113.876 130.957C114.852 131.745 115.733 132.643 116.502 133.634C118.048 135.372 120.129 137.797 122.392 140.514C124.655 143.232 126.676 145.707 128.11 147.526C128.932 148.469 129.678 149.476 130.343 150.536Z",
    fill: "#67266D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M135.384 145.967C135.263 146.068 131.495 141.926 126.989 136.874C122.483 131.823 118.907 127.449 119.038 127.348C119.169 127.247 122.918 131.328 127.423 136.44C131.929 141.552 135.506 145.856 135.384 145.967Z",
    fill: "#67266D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M410.867 272.5C410.867 183.656 338.844 111.634 250 111.634C161.156 111.634 89.1332 183.656 89.1332 272.5C89.1332 361.345 161.156 433.367 250 433.367C338.844 433.367 410.867 361.345 410.867 272.5Z",
    fill: "url(#paint3_linear_2468_15433)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M397.794 272.503C397.794 190.879 331.624 124.709 250 124.709C168.376 124.709 102.206 190.879 102.206 272.503C102.206 354.127 168.376 420.297 250 420.297C331.624 420.297 397.794 354.127 397.794 272.503Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M250.001 420.797C168.229 420.797 101.702 354.27 101.702 272.498C101.702 190.726 168.229 124.199 250.001 124.199C331.773 124.199 398.3 190.726 398.3 272.498C398.3 354.27 331.773 420.797 250.001 420.797ZM250.001 125.209C168.784 125.209 102.712 191.282 102.712 272.498C102.712 353.715 168.794 419.787 250.001 419.787C331.207 419.787 397.289 353.715 397.289 272.498C397.289 191.282 331.217 125.209 250.001 125.209Z",
    fill: "#263238"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M258.424 286.102C265.491 283.204 268.871 275.125 265.972 268.058C263.074 260.991 254.995 257.611 247.928 260.51C240.861 263.408 237.481 271.487 240.38 278.554C243.278 285.621 251.357 289.001 258.424 286.102Z",
    fill: "#FAFAFA"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M253.183 259.447C252.059 259.574 250.942 259.763 249.839 260.013C247.328 260.679 245.057 262.045 243.292 263.952C241.527 265.859 240.339 268.227 239.868 270.782C239.444 273.153 239.657 275.593 240.484 277.854C240.918 279.082 241.542 280.234 242.333 281.269C243.129 282.37 244.098 283.336 245.202 284.128C247.514 285.828 250.308 286.744 253.178 286.744C256.047 286.744 258.842 285.828 261.154 284.128C262.263 283.339 263.236 282.373 264.033 281.269C264.82 280.232 265.444 279.08 265.882 277.854C266.706 275.592 266.915 273.152 266.488 270.782C266.116 268.702 265.257 266.74 263.983 265.054C262.135 262.581 259.509 260.802 256.527 260.003C255.423 259.754 254.307 259.565 253.183 259.437C254.327 259.355 255.476 259.457 256.588 259.74C259.197 260.365 261.57 261.728 263.425 263.667C265.279 265.605 266.535 268.037 267.044 270.671C267.519 273.153 267.32 275.717 266.468 278.097C265.513 280.727 263.806 283.018 261.558 284.684C259.13 286.468 256.196 287.43 253.183 287.43C250.17 287.43 247.236 286.468 244.808 284.684C243.642 283.842 242.618 282.819 241.777 281.653C240.96 280.563 240.315 279.353 239.868 278.066C239.012 275.688 238.81 273.124 239.282 270.641C239.79 268.007 241.047 265.575 242.901 263.636C244.755 261.698 247.129 260.335 249.738 259.71C250.865 259.437 252.028 259.349 253.183 259.447Z",
    fill: "#263238"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M253.183 262.982C255.221 262.98 257.215 263.583 258.911 264.714C260.607 265.845 261.929 267.454 262.711 269.337C263.492 271.22 263.698 273.292 263.301 275.291C262.905 277.291 261.924 279.128 260.483 280.57C259.042 282.012 257.206 282.995 255.207 283.393C253.208 283.792 251.135 283.588 249.252 282.809C247.368 282.029 245.758 280.708 244.626 279.013C243.493 277.319 242.888 275.326 242.888 273.287C242.888 270.556 243.972 267.936 245.903 266.004C247.833 264.072 250.452 262.985 253.183 262.982Z",
    fill: "#263238"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M252.952 269.003C252.952 269.003 250.076 193.032 254.212 177.003C254.212 177.003 261.208 223.056 252.952 269.003Z",
    fill: "#263238"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M252.952 269.004C252.952 269.004 250.108 174.863 254.251 155.004C254.251 155.004 261.228 212.073 252.952 269.004Z",
    fill: "url(#paint4_linear_2468_15433)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M219.825 405.528L219.657 405.497L222.086 394.646L222.394 394.703L219.825 405.528ZM275.991 406.863L273.814 395.972L274.134 395.909L276.149 406.841L275.991 406.863ZM168.849 381.443L168.697 381.322L175.392 372.45L175.634 372.639L168.849 381.443ZM327.969 385.194L321.615 376.081L321.863 375.912L328.134 385.081L327.969 385.194ZM132.126 338.737L131.996 338.497L141.767 333.129L141.872 333.334L132.126 338.737ZM366.735 344.26L357.207 338.542L357.37 338.274L366.836 344.104L366.735 344.26ZM115.896 284.765L115.869 284.472L126.953 283.625L126.919 283.804L115.896 284.765ZM374.418 289.651L374.449 289.482L385.495 290.869L385.438 291.177L374.418 289.651ZM374.453 289.462L374.499 289.214L385.546 290.601L385.497 290.86L374.453 289.462ZM133.518 232.518L123.03 228.861L123.077 228.613L133.573 232.282L133.518 232.518ZM370.255 237.874L370.193 237.657L380.835 234.446L380.911 234.697L370.255 237.874ZM160.37 188.349L152.299 180.673L152.453 180.507L160.56 188.107L160.37 188.349ZM345.427 192.51L345.266 192.326L353.684 185.071L353.845 185.255L345.427 192.51ZM202.883 158.815L198.635 148.555L198.822 148.487L203.181 158.706L202.883 158.815ZM304.292 161.087L304.093 160.998L308.811 150.934L309.066 151.054L304.292 161.087ZM253.722 149.174L253.961 138.057L254.199 138.101L253.95 149.217L253.722 149.174Z",
    fill: "#263238"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2468_15433",
    x1: 232.32,
    y1: 86.7669,
    x2: 269.943,
    y2: 86.7669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A83B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0682,
    stopColor: "#9F3B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1813,
    stopColor: "#85399C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3245,
    stopColor: "#5C37AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3941,
    stopColor: "#4636B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#4139BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6082,
    stopColor: "#3143C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7397,
    stopColor: "#1852D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#0061DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2468_15433",
    x1: 353.662,
    y1: 136.133,
    x2: 388.543,
    y2: 136.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A83B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0682,
    stopColor: "#9F3B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1813,
    stopColor: "#85399C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3245,
    stopColor: "#5C37AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3941,
    stopColor: "#4636B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#4139BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6082,
    stopColor: "#3143C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7397,
    stopColor: "#1852D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#0061DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2468_15433",
    x1: 99.9012,
    y1: 143.983,
    x2: 135.009,
    y2: 143.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A83B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0682,
    stopColor: "#9F3B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1813,
    stopColor: "#85399C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3245,
    stopColor: "#5C37AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3941,
    stopColor: "#4636B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#4139BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6082,
    stopColor: "#3143C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7397,
    stopColor: "#1852D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#0061DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2468_15433",
    x1: 251.73,
    y1: 445.347,
    x2: 251.73,
    y2: 144.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A83B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0682,
    stopColor: "#9F3B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1813,
    stopColor: "#85399C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3245,
    stopColor: "#5C37AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3941,
    stopColor: "#4636B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#4139BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6082,
    stopColor: "#3143C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7397,
    stopColor: "#1852D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#0061DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2468_15433",
    x1: 251.814,
    y1: 212.617,
    x2: 256.495,
    y2: 212.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A83B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0682,
    stopColor: "#9F3B91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1813,
    stopColor: "#85399C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3245,
    stopColor: "#5C37AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3941,
    stopColor: "#4636B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#4139BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6082,
    stopColor: "#3143C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7397,
    stopColor: "#1852D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8367,
    stopColor: "#0061DC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtendClock);
export default __webpack_public_path__ + "static/media/ExtendClock.a62bce1767b0db03353ce26296af7253.svg";
export { ForwardRef as ReactComponent };